/**
 * Login constants
 */

export const LOGIN_REQUEST = 'local/RexelLogin/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'local/RexelLogin/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'local/RexelLogin/LOGIN_ERROR';
